(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-001-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (value) => String(value).padStart(2, '0');

    document.querySelectorAll('[data-mr-countdown]').forEach((countdown) => {
      if (countdown.dataset.initialized === 'true') return;
      countdown.dataset.initialized = 'true';

      const target = new Date(countdown.dataset.target).getTime();
      const status = countdown.querySelector('[data-countdown-status]');
      const fields = {
        days: countdown.querySelector('[data-countdown-days]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]')
      };

      const update = () => {
        if (Number.isNaN(target)) {
          status.textContent = 'Set a valid release date in the theme editor.';
          return true;
        }

        const remaining = target - Date.now();
        if (remaining <= 0) {
          Object.values(fields).forEach((field) => { field.textContent = '00'; });
          status.textContent = countdown.dataset.complete;
          countdown.classList.add('is-complete');
          return true;
        }

        fields.days.textContent = pad(Math.floor(remaining / 86400000));
        fields.hours.textContent = pad(Math.floor((remaining % 86400000) / 3600000));
        fields.minutes.textContent = pad(Math.floor((remaining % 3600000) / 60000));
        fields.seconds.textContent = pad(Math.floor((remaining % 60000) / 1000));
        return false;
      };

      if (!update()) {
        const timer = window.setInterval(() => {
          if (update()) window.clearInterval(timer);
        }, 1000);
      }
    });

    document.querySelectorAll('[data-klaviyo-home]').forEach((capture) => {
      capture.dataset.klaviyoReady = 'true';
    });

    window.addEventListener('klaviyoForms', (event) => {
      if (event.detail?.type !== 'submit') return;
      document.querySelectorAll('[data-klaviyo-home]').forEach((capture) => {
        if (capture.dataset.formId && capture.dataset.formId !== event.detail.formId) return;
        const success = capture.querySelector('.mr-email__success');
        if (success) success.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-creators-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-klaviyo-open]').forEach((button)=>{button.addEventListener('click',()=>{window._klOnsite=window._klOnsite||[];window._klOnsite.push(['openForm',button.dataset.klaviyoOpen]);});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-email-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mr-popup').forEach((popup) => {
    if (popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';
    const key = `mrPopupSeen:${popup.id}`;
    const lastSeen = Number(localStorage.getItem(key) || 0);
    const waitDays = Number(popup.dataset.days || 14) * 86400000;
    if (Date.now() - lastSeen > waitDays) window.setTimeout(() => popup.showModal(), Number(popup.dataset.delay || 6000));
    popup.querySelector('.mr-popup__close')?.addEventListener('click', () => { localStorage.setItem(key, String(Date.now())); popup.close(); });
    popup.querySelector('[data-klaviyo-trigger]')?.addEventListener('click', (event) => {
      const formId = event.currentTarget.dataset.klaviyoTrigger;
      if (!formId) { if (window.Shopify?.designMode) window.alert('Add a Klaviyo form ID in the popup settings.'); return; }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
      localStorage.setItem(key, String(Date.now()));
      popup.close();
    });
    popup.addEventListener('click', (event) => { if (event.target === popup) { localStorage.setItem(key, String(Date.now())); popup.close(); } });
  });

  } catch(e) { console.error(e); }
})();
})();
